import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import './plugins';
import '@/assets/scss';
import '@/assets/icon/iconfont';
import '@/assets/font/iconfont';

import * as fundebug from 'fundebug-javascript';
import fundebugVue from 'fundebug-vue';
fundebug.apikey = 'a0771bacf610ef70c881ac0243219bf10cd94c286387b4a9377c03b3cce68971';
fundebugVue(fundebug, Vue);

require('fundebug-revideo');

import BaseButton from '@/components/base/BaseButton';

Vue.config.productionTip = false;

Vue.component(BaseButton.name, BaseButton);

new Vue({
	router,
	store,
	render: (h) => h(App)
	// mounted() {
	// 	document.dispatchEvent(new Event('render-event'));
	// }
}).$mount('#app');
